import { render, staticRenderFns } from "./BaseNotification.vue?vue&type=template&id=b179b1e8&scoped=true"
import script from "./BaseNotification.vue?vue&type=script&lang=js"
export * from "./BaseNotification.vue?vue&type=script&lang=js"
import style0 from "./BaseNotification.vue?vue&type=style&index=0&id=b179b1e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b179b1e8",
  null
  
)

export default component.exports